function eventDispatcher(eventKey: any, detail: any) {
  const event = new CustomEvent(eventKey, {
    detail,
  })
  window.dispatchEvent(event)
}

export default eventDispatcher
